'use client';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { memo, useEffect } from 'react';
interface Props {
    fromPage: string | string[] | undefined;
}
const Backbutton: React.FC<Props> = ({ fromPage }) => {
    const prevPage = Array.isArray(fromPage) ? fromPage[0] : fromPage || 'screener';
    const router = useRouter();
    const handleBackspaceClick = (e: KeyboardEvent) => {
        const isKeyBoardInFocus = document.querySelector(':focus');
        if (isKeyBoardInFocus) return;
        if (e.key === 'Backspace') router.push(`/${prevPage}`);
    };
    useEffect(() => {
        window.addEventListener('keydown', handleBackspaceClick);
        return () => window.removeEventListener('keydown', handleBackspaceClick);
    }, []);
    return (
        <div className="col-4 col-lg-9 ps-0" style={{ textAlign: 'start', backgroundColor: 'white' }}>
            <nav aria-label="breadcrumb">
                <Link href={`/${prevPage}`} className="d-inline-flex align-center mt-1 gap-2 text-primary">
                    <span className="fw-bold ms-1">←</span>
                    <span>Back</span>
                </Link>
            </nav>
        </div>
    );
};
export default memo(Backbutton);
